module.exports = __webpack_public_path__ + "img/img-seven-day.732dcd4e.png";